<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <card>
          <LineDeviationReportFormVue></LineDeviationReportFormVue>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import LineDeviationReportFormVue from '@/components/Report2/LineDeviationReportForm.vue'

export default {
  name: 'LineDeviationReport',
  components: {
    LineDeviationReportFormVue,
  },
}
</script>
